export const productIsParkTicket = !!(document.querySelector('[data-js-product-ticket]'))
export const productIsFantissima = !!(document.querySelector('[data-js-product-fantissima]'))
export const productIsVoucher = !!(document.querySelector('[data-js-product-voucher]'))
export const productIsFreeTicket = !!(document.querySelector('[data-js-product-free-ticket]'))
export const isPrototype = !!(document.querySelector('[data-js-is-prototype]'))
export const alertNoCalendarEntrySelected = document.querySelector('[data-js-calendar-alert]')
const htmlTag = document.getElementsByTagName('html')[0]
export const locale = htmlTag.getAttribute('lang')
export const currency = htmlTag.dataset.jsCurrency
